export enum SenderStatus {
  ACTIVE = "ACTIVE",
  UNAUTHORIZED = "UNAUTHORIZED",
  DELETED = "DELETED"
}

export const senderStatusArray = Object.values(SenderStatus);

type SenderStatusPropertiesType = {
  [key in SenderStatus]: {
    value: string;
    color: string;
    description: string;
  };
};

export const SenderStatusProperties: SenderStatusPropertiesType = {
  [SenderStatus.ACTIVE]: {
    value: "Active",
    color: "brand",
    description: "Sender's email address is authorized to send emails by Mailjet."
  },
  [SenderStatus.UNAUTHORIZED]: {
    value: "Unauthorized",
    color: "grey",
    description: "Sender's email address is not authorized to send emails by Mailjet."
  },
  [SenderStatus.DELETED]: {
    value: "Deleted",
    color: "grey",
    description: "Sender was deleted, recreate to use it."
  }
};
